export default "__VITE_ASSET__DgW$gcB9__"